import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import * as fromRoot from '@app/store';
import * as fromUser from '@app/store/user';

/**
 * Guard que verifica si el usuario tiene acceso basado en su username
 * Utiliza la propiedad 'usernames' en route.data para determinar los usernames permitidos
 */

@Injectable({
  providedIn: 'root'
})
export class DocumentoGuard implements CanActivate {

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.pipe(
      select(fromUser.getUser),
      filter(user => !!user), // Esperar a que el usuario esté cargado
      map(user => {
        const userUsername = user?.username || '';
        const allowedUsernames = route.data['usernames'] as string[] || [];

        // Si no hay usernames especificados, permitir acceso
        if (allowedUsernames.length === 0) {
          return true;
        }

        // Verificar si el username del usuario está en la lista de usernames permitidos
        const hasAccess = allowedUsernames.includes(userUsername);

        if (!hasAccess) {
          console.warn(`Acceso denegado. Usernames permitidos: ${allowedUsernames.join(', ')}, Username actual: ${userUsername}`);
          // Redirigir a página de acceso denegado o home
          this.router.navigate(['/home']);
        }

        return hasAccess;
      })
    );
  }
}
